import React from "react";
import GamePageTemplate from "../GamePageTemplate";

const FishingPage = () => {
  return (
    <GamePageTemplate
      // pageTitle="Fishing Lobby"
      // bannerTitle="Fishing Lobby"
      bannerImage="/images/fishing-banner.png"
      fetchParams={{ isLiveGame: false }}
      fixedGameType="fish"
      showGameTypeFilter={false}
    />
  );
};

export default FishingPage;
